import HttpService from '@/api/HttpService';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    verifyMicroDeposit(_, { microDeposit }) {
      const { fundingSourceId } = microDeposit;
      const { amount1, amount2 } = microDeposit.requestBody;
      const payload = {
        fundingSourceId,
        amount1,
        amount2,
      };
      return HttpService.postV2(`funding-sources/${fundingSourceId}/verify-micro-deposits`, payload);
    },
    getMicroDepositStatus(_, { fundingSourceId }) {
      return HttpService.get(`funding-source/${fundingSourceId}/micro-deposit`);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/microDepositsVerification.js